var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"dpv-list page page-with-table p-2"},[_c('div',{staticClass:"card content-wrapper p-2"},[_c('DpvTable')],1)])}
var staticRenderFns = []

export { render, staticRenderFns }